import * as React from "react";
import type { SVGProps } from "react";
const SvgIconNumberTwoCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.26.82c-1.93.13-3.8.76-5.4 1.8-1.28.85-2.4 1.96-3.23 3.24-.68 1.03-1.22 2.27-1.51 3.46-.74 3.03-.2 6.23 1.5 8.82.85 1.28 1.96 2.4 3.24 3.23 1.03.68 2.27 1.22 3.46 1.51 3.03.74 6.24.2 8.82-1.5q1.93-1.29 3.22-3.22c.82-1.24 1.4-2.7 1.67-4.16.42-2.35.1-4.73-.94-6.86-.57-1.18-1.25-2.14-2.17-3.06q-1.93-1.92-4.55-2.77c-1.28-.4-2.74-.58-4.11-.5m0 1.71c-2.88.23-5.53 1.78-7.14 4.18q-1.24 1.85-1.54 4.14c-.07.47-.07 1.83 0 2.3.15 1.13.42 2.05.91 3.04.48.97 1.04 1.75 1.8 2.52.77.77 1.55 1.32 2.52 1.8 1 .49 1.9.76 3.04.91.47.07 1.83.07 2.3 0 1.14-.15 2.05-.42 3.04-.91.97-.48 1.75-1.03 2.52-1.8s1.32-1.55 1.8-2.52c.4-.8.63-1.51.8-2.35.14-.71.16-.94.16-1.84s-.02-1.13-.16-1.84c-.17-.84-.4-1.54-.8-2.35-.48-.97-1.03-1.75-1.8-2.52s-1.55-1.32-2.52-1.8c-.98-.48-1.85-.75-2.95-.9-.27-.04-.5-.05-1.1-.06zm-.41 3.85c-1.07.12-2.03.79-2.52 1.73-.18.36-.25.58-.23.77.05.54.58.9 1.1.75.27-.08.41-.23.6-.61q.29-.6.82-.82c.27-.11.36-.12 1.5-.1 1.22 0 1.2 0 1.55.23.4.27.66.74.66 1.21 0 .18-.07.47-.16.66-.1.22-.4.53-.6.63l-1.97.87-2 .9c-.78.43-1.38 1.25-1.58 2.16-.03.18-.04.33-.04 1.24v1.03l.06.12q.21.39.62.47c.18.03 6.5.03 6.68 0q.41-.1.61-.47c.06-.1.07-.15.07-.36s0-.26-.06-.37c-.12-.26-.36-.44-.64-.48-.08-.02-1.27-.03-2.9-.03H9.68v-.3c0-.38.05-.61.17-.87.13-.27.39-.53.65-.66l1.93-.86 1.95-.87c.8-.43 1.39-1.2 1.6-2.14.07-.27.07-1.01 0-1.3-.23-1.12-1.04-2.02-2.12-2.38-.41-.14-.51-.15-1.72-.16z"
      fill="#B73D06"
    />
  </svg>
);
export default SvgIconNumberTwoCircle;
